module.exports = __webpack_public_path__ + "static/media/Portugal_Ghana.e07252a1.jpeg";